var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDateBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 238,
    viewBox: "0 0 214 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.222 23.8H166.444V0H142.667V23.8H71.3333V0H47.5556V23.8H23.7778C10.6643 23.8 0 34.4743 0 47.6V214.2C0 227.326 10.6643 238 23.7778 238H190.222C203.336 238 214 227.326 214 214.2V47.6C214 34.4743 203.336 23.8 190.222 23.8ZM178.333 202.3H107V130.9H178.333V202.3ZM190.222 83.3H23.7778V59.5H190.222V83.3Z",
    fill: "#2A5BA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDateBlue);
export default __webpack_public_path__ + "static/media/icon-date-blue.64b183848db0967b312fb6a102805221.svg";
export { ForwardRef as ReactComponent };